import React, { Component } from "react";
import FeedPost from "./feed-post";

class FacebookFeed extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (global.canUseDOM) {
            const elem = document.createElement("div");
            elem.id = "fb-root";

            document.body.insertBefore(elem, document.body.children[0]);

            const f = function (d, s, id) {
                var js,
                    fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s);
                js.id = id;
                js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.8";
                fjs.parentNode.insertBefore(js, fjs);
            };
            f(document, "script", "facebook-jssdk");
        }
    }

    render() {
        if (this.props.Payload)
            return (
                <div className="social-feed-container">
                    {this.props.Payload.Posts && (
                        <div className="social-feed">
                            <div className="social-feed__inner">
                                <div className="social-feed__header">
                                    <h1
                                        className="social-feed__header__title"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.Payload.FacebookFeedTitle
                                        }}
                                    />
                                    <div
                                        className="social-feed__header__follow"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.Payload.FollowWidgetScript
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="social-feed__list">
                                <div className="social-feed__list__inner">
                                    {this.props.Payload.Posts.map((post, i) => {
                                        return (
                                            <div key={i} className="social-feed__list__item ">
                                                {<FeedPost post={post} />}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        return null;
    }
}
export default FacebookFeed;
